import { render, staticRenderFns } from "./claimbatchList.vue?vue&type=template&id=772647b1&"
import script from "./claimbatchList.vue?vue&type=script&lang=js&"
export * from "./claimbatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports